(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["genesyx-experience-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('genesyx-experience-tabs')) {
    customElements.define('genesyx-experience-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabsWrap = this.querySelector('.gx-experience__tabs-wrap');
        this.panelsContainer = this.querySelector('.gx-experience__panels');
        this.previousButton = this.querySelector('[data-experience-previous]');
        this.nextButton = this.querySelector('[data-experience-next]');
        this.position = this.querySelector('[data-experience-position]');
        this.interval = Number(this.dataset.interval) || 7000;
        this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.setActive(index, false);
            this.restart();
          });
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.panelsContainer?.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.panelsContainer?.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.panelsContainer?.addEventListener('pointercancel', () => { this.swipeStart = null; });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });
        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest('[data-panel-index]');
          if (panel) this.setActive(Number(panel.dataset.panelIndex), false);
        });
        this.warmMedia();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      // Lazy images inside hidden panels never enter the viewport, so tabs 2-5 would stay empty forever.
      // Deliberately not IntersectionObserver-driven: its callbacks do not fire reliably on this page.
      warmMedia() {
        const load = () => this.querySelectorAll('img[loading="lazy"]').forEach((image) => { image.loading = 'eager'; });
        const schedule = () => {
          if (window.requestIdleCallback) window.requestIdleCallback(load, { timeout: 1500 });
          else window.setTimeout(load, 200);
        };
        if (document.readyState === 'complete') schedule();
        else window.addEventListener('load', schedule, { once: true });
      }

      setActive(index, moveFocus) {
        const safeIndex = (index + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === safeIndex;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          this.panels[tabIndex].hidden = !active;
        });
        if (this.position) this.position.textContent = `${safeIndex + 1} / ${this.tabs.length}`;
        if (moveFocus) this.tabs[safeIndex].focus();
        const activeTab = this.tabs[safeIndex];
        if (this.tabsWrap && activeTab) {
          const target = activeTab.offsetLeft - ((this.tabsWrap.clientWidth - activeTab.offsetWidth) / 2);
          this.tabsWrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
        }
      }

      move(step) {
        const current = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        this.setActive(current + step, false);
        this.restart();
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse') return;
        this.swipeStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }

      onPointerUp(event) {
        if (!this.swipeStart || this.swipeStart.id !== event.pointerId) return;
        const deltaX = event.clientX - this.swipeStart.x;
        const deltaY = event.clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
        this.move(deltaX < 0 ? 1 : -1);
      }

      onKeydown(event, index) {
        let nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        this.setActive(nextIndex, true);
        this.restart();
      }

      start() {
        if (!this.autoplay || this.timer || this.tabs.length < 2 || document.hidden) return;
        this.timer = window.setInterval(() => {
          const current = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          this.setActive((current + 1) % this.tabs.length, false);
        }, this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["genesyx-slow-marquee"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.genesyx-marquee').forEach((section) => {
    if (section.dataset.marqueeControlsReady === 'true') return;

    const track = section.querySelector('.genesyx-marquee__track');
    const group = section.querySelector('.genesyx-marquee__group');
    const firstCard = section.querySelector('.genesyx-marquee__card');
    const viewport = section.querySelector('.genesyx-marquee__viewport');

    if (!track || !group || !firstCard || !viewport) return;

    section.dataset.marqueeControlsReady = 'true';

    let activePointer = null;
    let startX = 0;
    let startTime = 0;
    let dragged = false;
    let suppressClick = false;

    const getDuration = () => Number.parseFloat(window.getComputedStyle(section).getPropertyValue('--genesyx-marquee-speed')) * 1000;

    const normalizeTime = (time, duration) => {
      return ((time % duration) + duration) % duration;
    };

    viewport.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.button !== 0) return;

      const animation = track.getAnimations()[0];
      if (!animation || typeof animation.currentTime !== 'number') return;

      activePointer = event.pointerId;
      startX = event.clientX;
      startTime = animation.currentTime;
      dragged = false;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
      animation.pause();
    });

    viewport.addEventListener('pointermove', (event) => {
      if (event.pointerId !== activePointer) return;

      const distance = event.clientX - startX;
      if (!dragged && Math.abs(distance) < 6) return;

      dragged = true;
      event.preventDefault();

      const animation = track.getAnimations()[0];
      if (!animation) return;

      const duration = getDuration();
      const timeShift = distance / group.scrollWidth * duration;
      animation.currentTime = normalizeTime(startTime - timeShift, duration);
    }, { passive: false });

    const finishSwipe = (event) => {
      if (event.pointerId !== activePointer) return;

      const animation = track.getAnimations()[0];
      if (animation) animation.play();

      if (viewport.hasPointerCapture(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }

      activePointer = null;
      viewport.classList.remove('is-dragging');

      if (dragged) {
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      }
    };

    viewport.addEventListener('pointerup', finishSwipe);
    viewport.addEventListener('pointercancel', finishSwipe);

    viewport.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    section.querySelectorAll('[data-marquee-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = Number(button.dataset.marqueeDirection);
        const groupStyles = window.getComputedStyle(group);
        const gap = Number.parseFloat(groupStyles.columnGap || groupStyles.gap) || 0;
        const cardStep = firstCard.getBoundingClientRect().width + gap;
        const animation = track.getAnimations()[0];

        if (animation && typeof animation.currentTime === 'number') {
          const duration = Number.parseFloat(window.getComputedStyle(section).getPropertyValue('--genesyx-marquee-speed')) * 1000;
          const timeStep = cardStep / group.scrollWidth * duration;
          animation.currentTime = (animation.currentTime + direction * timeStep + duration) % duration;
          return;
        }

        viewport.scrollBy({ left: direction * cardStep, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      /* PERF FIX: passive scroll listener — onScroll only reads window.pageYOffset (no forced reflow) and never calls preventDefault, so the browser can keep scrolling on the compositor thread instead of waiting on JS */
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
